import TomSelect from "tom-select"

const tom_select = function () {
    document.querySelectorAll('.tom-select').forEach((element) => {
        const classNames = ['ts-wrapper', 'tomselected']
        if (!classNames.some(className => element.classList.contains(className))) {
            let settings = {
                create: false,
                sortField: {
                    field: "text",
                    direction: "asc"
                },
                maxOptions: null // tom-select will truncate the select to 50 options by default
            };

            new TomSelect(element, settings);
        }
    });
};

$(document).on('turbo:load', tom_select);